/* import __COLOCATED_TEMPLATE__ from './other-settings.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();